module.exports = __webpack_public_path__ + "static/media/logo-9.643e8704.jpg";